var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 44.5522V25.0087L5.03906 15.3065V31.7521C5.03906 32.7116 5.2753 33.5949 5.74776 34.4022C6.22023 35.2094 6.86733 35.8529 7.68906 36.3326L22 44.5522ZM26 44.5522L40.3109 36.3326C41.1326 35.8529 41.7797 35.2094 42.2522 34.4022C42.7246 33.5949 42.9609 32.7116 42.9609 31.7521V15.2499L26 24.9804V44.5522ZM34.3739 15.5826L40.7261 11.9065L26.65 3.81518C25.8282 3.33545 24.9449 3.09558 24 3.09558C23.055 3.09558 22.1717 3.33545 21.3499 3.81518L17.626 5.95213L34.3739 15.5826ZM23.9717 21.5587L30.3174 17.9326L13.6195 8.25213L7.19556 11.9565L23.9717 21.5587Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.4032d4bf0af5b2150327892592215169.svg";
export { ForwardRef as ReactComponent };